import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import Form from './form';
import { generalClasses as styles } from './styles';

const Edit = props => {
  const {
    classes,
    location: { entity }
  } = props;

  return (
    <Card className={classes.card}>
      <CardHeader title="Modificar Empresa" />
      <CardContent className={classes.cardContent}>
        <Card className={classes.formCard}>
          <CardContent className={classes.cardContent}>
            <Form company={entity} {...props} />
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(Edit);
